import { useEffect, useState } from 'react';

const KEY = 'th-mkt-theme';

export const useMarketingTheme = () => {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, theme); } catch { /* storage unavailable */ }
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'light' ? '#F7F9FC' : '#0B1220');
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    try { root.setAttribute('data-cb', localStorage.getItem('th-colorblind') === 'on' ? 'on' : 'off'); } catch { /* ignore */ }
    const prev = root.style.scrollPaddingTop;
    root.style.scrollPaddingTop = '80px';
    return () => { root.style.scrollPaddingTop = prev; };
  }, []);

  return [theme, () => setTheme((t) => (t === 'light' ? 'dark' : 'light'))];
};
